import {BehaviorSubject} from 'rxjs';
import {IDataDiscipline} from "../_interfaces/IDataDiscipline";

interface InfoDiscipline {
    popOpen: boolean
    popEl: Element | HTMLElement | null
    pop: IDataDiscipline | null
}

const InfoDisciplineBehaveSubscriber = new BehaviorSubject<InfoDiscipline>({popOpen: false, popEl: null, pop: null});

export {
    InfoDisciplineBehaveSubscriber
}
